import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import {
    LOADER_TIMEOUT_TIME,
    ROLE,
    SWAL_SETTINGS,
    showFilterlist,
    showFilterlistCms,
} from "../../../../utils/Constants";
import {
    capitalizeFirstLetter,
    extractTime,
    formateDate,
    formateDateWithMonth,
    handleServerValidations,
    removeSpecialCharacter,
    TrimText,
} from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import CustomRangepicker from "../../common/rangepicker";
import { Delete, List, Status } from "../../services/staff.services";
import { historyFeedback } from "../../../doctor/services/patient.services";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const AppointmentHistory = () => {
    const { t } = useTranslation();
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [statsupdate, setStatusUpdate] = useState("false");
    const [featuredStatsupdate, setFeaturedStatusUpdate] = useState("false");
    const [datalength, setDataLength] = useState("");
    const [itemperpage] = useState(10);
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true);
    const [search, setSearch] = useState({});
    const [globalsearch, setGlobalSearch] = useState("");
    const breadcrumbs = [
        { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
        { title: t("Completed Appointments"), url: "/admin/management-section/completed-appointment/list/1" },
        { title: t("View Feedback History"), url: "" },
    ];

    const appointmentID = location?.state?.appointment_id

    useEffect(() => {
        const getData = setTimeout(() => {
            if (search) {
                setLoader(true);
                const formData = new FormData();
                formData.append("page", params.pgno);
                formData.append("per_page", itemperpage);
                formData.append("sort", JSON.stringify(sorting));
                formData.append("search", JSON.stringify(search));
                formData.append("global_search", globalsearch);
                formData.append("appointment_id", appointmentID);
                historyFeedback(formData, ROLE.SUPER_ADMIN)
                    .then((data) => {
                        setDataLength(data.data.total_records);
                        // setSerialNo(data.data.offset);
                        setList(data && data.data && data.data.list ? data.data.list : []);
                        //   console.log("data.data.data_ids", data.data.data_ids);
                        setPage(data && data.data && data.data.page ? data.data.page : 1);
                        setLoader(false);
                    })
                    .catch((error) => {
                        console.log("error ====> ", error);
                    });
            }
        }, 300);
        return () => clearTimeout(getData)
    }, [
        location,
        statsupdate,
        sorting,
        search,
        globalsearch,
        itemperpage,
        params.pgno,
    ]);


    // const headerMapping = {
    //     "appointment_id": "Appointment ID",
    //     "appointment_date": "Appointment Date",
    //     "reason": "Reason",
    //     "feedback": "Feedback",
    // };


    // const handleExport = () => {
    //     const formData = new FormData();
    //     formData.append("page", 1);
    //     formData.append("per_page", datalength);
    //     formData.append("sort", JSON.stringify({}));
    //     formData.append("search", JSON.stringify({}));
    //     formData.append("global_search", globalsearch);

    //     historyFeedback(formData, ROLE.SUPER_ADMIN)
    //         .then(data => {
    //             setDataLength(data.data.total_records);

    //             const listData = (data?.data?.list || []);

    //             const printData = listData.map((item) => {
    //                 const transformedItem = {};
    //                 const appointmentID = item?.appointment?.appointment_register_id ? '#' + item?.appointment?.appointment_register_id : "-";
    //                 const appointmentDate = item?.appointment?.appointment_date ? formateDate(item.appointment?.appointment_date) : "-";
    //                 const reason = item?.reason ? capitalizeFirstLetter(item.reason) : "-";
    //                 const feedback = item?.feedback ? capitalizeFirstLetter(item.feedback) : "-";

    //                 transformedItem[headerMapping["appointment_id"]] = appointmentID;
    //                 transformedItem[headerMapping["appointment_date"]] = appointmentDate;
    //                 transformedItem[headerMapping["reason"]] = reason;
    //                 transformedItem[headerMapping["feedback"]] = feedback;

    //                 return transformedItem;
    //             });

    //             const ws = XLSX.utils.json_to_sheet(printData, { header: Object.values(headerMapping) });
    //             const wb = XLSX.utils.book_new();
    //             XLSX.utils.book_append_sheet(wb, ws, 'Feedback Appointments');
    //             const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    //             const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    //             saveAs(blob, 'feedback_appointments.xlsx');

    //             setTimeout(() => {
    //                 setLoader(false);
    //             }, LOADER_TIMEOUT_TIME);
    //         })
    //         .catch(error => {
    //             console.error("Export error: ", error);
    //             setTimeout(() => {
    //                 setLoader(false);
    //             }, LOADER_TIMEOUT_TIME);
    //         });
    // };

    return (
        <>
            {/* table section */}
            <Breadcrums data={breadcrumbs} />
            <div className="animation_fade">
                <div className="card custom-card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <h6 className="main-content-label">
                                {t("View Feedback History")}
                            </h6>
                            {/* <div className="d-flex align-items-center">
                                <button className="btn ripple btn-main-primary signbtn mr-2" onClick={handleExport} disabled={datalength === 0}>Export Report</button>
                            </div> */}
                        </div>
                        <div className="table-responsive">
                            <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                                <thead>
                                    <tr>
                                        <th>Appointment ID</th>
                                        <th>Appointment Date</th>
                                        <th>Appointment Time</th>
                                        <th>Feedback</th>
                                        <th>Reason</th>
                                        <th>Created Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ? (
                                        <tr>
                                            <td colSpan={14}>
                                                <Loader />
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {list.length ? (
                                                list.map((row, i) => {
                                                    return (
                                                        <tr
                                                            key={i}
                                                        >
                                                            <td>{row?.appointment?.appointment_register_id ? '#' + (row?.appointment?.appointment_register_id) : "-"}</td>
                                                            <td>{formateDate(row?.appointment?.appointment_date)}</td>
                                                            <td>{extractTime(row?.appointment?.appointment_date)}</td>
                                                            <td>
                                                                {row?.feedback ? (
                                                                    <div className="d-flex">
                                                                        {row?.feedback ? capitalizeFirstLetter((row.feedback)) : "N/A"}
                                                                    </div>
                                                                ) : (
                                                                    <div className="d-flex">-</div>
                                                                )}
                                                            </td>
                                                            <td>{row?.reason ? capitalizeFirstLetter(row.reason) : "-"}</td>
                                                            <td>
                                                                {row.createdAt
                                                                    ? formateDateWithMonth(row.createdAt)
                                                                    : "N/A"}
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={14} className="text-center">
                                                        {t("admin.message.msg_no_records")}
                                                    </td>
                                                </tr>
                                            )}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div
                            className=""
                            id="example1_info"
                            role="status"
                            aria-live="polite"
                        >
                            <b>
                                {t("admin.message.msg_total_records")} : {datalength ? datalength : "0"}
                            </b>
                        </div>
                        {datalength && datalength > 0 ? (
                            <CustomPagination
                                datalength={datalength}
                                itemperpage={itemperpage}
                                currentPage={page}
                                setPage={setPage}
                                pageRoute={[
                                    {
                                        name: "Cafes",
                                        path: "/admin/management-section/completed-appointment/view/list",
                                    },
                                ]}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default AppointmentHistory;
